var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.636 4.54544V10.6064C15.636 10.9904 15.4862 11.3184 15.1861 11.5911C14.886 11.8637 14.5261 12 14.1058 12H1.89352C1.47379 12 1.11331 11.8637 0.813189 11.5911C0.513616 11.3184 0.363281 10.9904 0.363281 10.6064V4.54544L8.01446 7.63631L15.636 4.54544ZM15.636 3.60621L8.01446 6.72756L0.363281 3.60621V1.39416C0.363281 1.01016 0.513616 0.681566 0.813189 0.40894C1.11331 0.136313 1.47379 0 1.89352 0H14.1058C14.5261 0 14.886 0.136313 15.1861 0.40894C15.4862 0.681566 15.636 1.01016 15.636 1.39416V3.60621Z",
  fill: "white"
})));
export default SvgIconEmail;